import React, { useState, useEffect } from 'react';
import './App.css';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import ComingSoon from './ComingSoon';
import { 
  Calendar, 
  FileText, 
  Tool, 
  MessageCircle, 
  ArrowRight, 
  CheckCircle, 
  XCircle,
  Zap, 
  Star,
  Package,
  Clock,
} from 'react-feather';

function App() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  useEffect(() => {
    const handleLocationChange = () => {
      setCurrentPath(window.location.pathname);
    };

    window.addEventListener('popstate', handleLocationChange);
    return () => window.removeEventListener('popstate', handleLocationChange);
  }, []);

  // Route: Privacy Policy
  if (currentPath === '/privacy') {
    return (
      <div className="App">
        <header className="App-header">
          <nav>
            <div className="logo">
              <a href="/" style={{ textDecoration: 'none', color: 'inherit' }}><h1>CarVerse360</h1></a>
            </div>
            <ul className="nav-links">
              <li><a href="/">Home</a></li>
              <li><a href="/terms">Terms</a></li>
              <li><a href="https://app.carverse360.com" className="fw-bold">Launch App</a></li>
            </ul>
          </nav>
        </header>
        <main>
          <PrivacyPolicy />
        </main>
        <footer>
          <p>&copy; 2026 CarVerse360, Inc. All rights reserved. | <a href="/privacy">Privacy Policy</a> | <a href="/terms">Terms of Service</a></p>
        </footer>
      </div>
    );
  }

  // Route: Terms of Service
  if (currentPath === '/terms') {
    return (
      <div className="App">
        <header className="App-header">
          <nav>
            <div className="logo">
              <a href="/" style={{ textDecoration: 'none', color: 'inherit' }}><h1>CarVerse360</h1></a>
            </div>
            <ul className="nav-links">
              <li><a href="/">Home</a></li>
              <li><a href="/privacy">Privacy</a></li>
              <li><a href="https://app.carverse360.com" className="fw-bold">Launch App</a></li>
            </ul>
          </nav>
        </header>
        <main>
          <TermsOfService />
        </main>
        <footer>
          <p>&copy; 2026 CarVerse360, Inc. All rights reserved. | <a href="/privacy">Privacy Policy</a> | <a href="/terms">Terms of Service</a></p>
        </footer>
      </div>
    );
  }

  // Route: Store / Shop
  if (currentPath === '/store') {
    return (
      <div className="App">
        <header className="App-header">
          <nav>
            <div className="logo">
              <a href="/" style={{ textDecoration: 'none', color: 'inherit' }}><h1>CarVerse360</h1></a>
            </div>
            <ul className="nav-links">
              <li><a href="/">Home</a></li>
              <li><a href="https://app.carverse360.com" className="fw-bold">Launch App</a></li>
            </ul>
          </nav>
        </header>
        <main>
          <ComingSoon />
        </main>
        <footer>
          <p>&copy; 2026 CarVerse360, Inc. All rights reserved. | <a href="/privacy">Privacy Policy</a> | <a href="/terms">Terms of Service</a></p>
        </footer>
      </div>
    );
  }

  // Main Landing Page
  return (
    <div className="App">
      <header className="App-header">
        <nav>
          <div className="logo">
            <a href="/" style={{ textDecoration: 'none', color: '#fff', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ 
                background: 'var(--accent-primary)', 
                width: '36px', 
                height: '36px', 
                display: 'inline-flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                borderRadius: '10px', 
                fontWeight: 800,
                fontSize: '1rem',
                color: '#fff'
              }}>CV</span>
              <h1>CarVerse360</h1>
            </a>
          </div>
          <ul className="nav-links">
            <li><a href="#features">Features</a></li>
            <li><a href="#why-us">Why Us</a></li>
            <li><a href="#testimonials">Reviews</a></li>
            <li><a href="/store">Shop</a></li>
            <li><a href="https://app.carverse360.com/login" className="login-link">Sign In</a></li>
            <li><a href="https://app.carverse360.com/signup" className="signup-btn">Launch Fleet App</a></li>
          </ul>
        </nav>
      </header>
      
      <main>
        {/* Hero Section */}
        <section className="hero">
          <div className="hero-content">
            <div className="hero-badge">
              <Zap size={15} color="#ff8254" style={{ marginRight: '6px' }} />
              <span>THE OPERATING ENGINE FOR TURO HOSTS & RENTAL FLEETS</span>
            </div>
            <h2>Fleet Automation, <span className="gradient-text">Perfected.</span></h2>
            <p>CarVerse360 is the ultimate high-performance command center for car-sharing hosts and rental fleets. We automate your bookings, reconcile tolls, track tire health, and schedule maintenance so you can scale on autopilot.</p>
            <div className="hero-buttons">
              <a href="https://app.carverse360.com/signup" className="cta-button primary">Start Free Fleet Beta <ArrowRight size={16} style={{ marginLeft: '6px' }} /></a>
              <a href="https://app.carverse360.com/login" className="cta-button secondary">Sign In to Dashboard</a>
            </div>
            <div className="trust-indicators">
              <span><CheckCircle size={14} color="#10b981" /> 2-Minute OAuth Setup</span>
              <span><CheckCircle size={14} color="#10b981" /> No Credit Card Required</span>
              <span><CheckCircle size={14} color="#10b981" /> 100% Tenant Isolated</span>
            </div>
          </div>
        </section>

        {/* Live Metrics Bar */}
        <section className="metrics-bar">
          <div className="metrics-container">
            <div className="metric-item">
              <h3>0-Touch</h3>
              <p>Gmail Cloud Booking Sync</p>
            </div>
            <div className="metric-item">
              <h3>5+ Hrs</h3>
              <p>Saved Per Week in Admin Work</p>
            </div>
            <div className="metric-item">
              <h3>100%</h3>
              <p>Toll Invoicing Accuracy</p>
            </div>
            <div className="metric-item">
              <h3>4-Wheel</h3>
              <p>PSI & 32nds Tread Telematics</p>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section id="features" className="features">
          <div className="section-title">
            <span className="badge-subtitle">CORE CAPABILITIES</span>
            <h2>Everything You Need to Scale</h2>
            <p>Built from scratch to eliminate spreadsheets, catch missed tolls, and protect vehicle resale values.</p>
          </div>
          
          <div className="feature-cards">
            <div className="card">
              <div className="card-icon">
                <Calendar size={24} color="#ff6b35" />
              </div>
              <h3>Automated Turo Sync</h3>
              <p>Connect your host Gmail via official Google OAuth2. Our background cloud engine polls booking confirmations twice daily to auto-populate calendars, guest details, and odometers without Chrome extensions or open tabs.</p>
              <span className="pill-badge">24/7 Cloud Background Polling</span>
            </div>

            <div className="card">
              <div className="card-icon">
                <FileText size={24} color="#ff6b35" />
              </div>
              <h3>Toll Invoicing & DriveKS</h3>
              <p>Upload statement CSVs directly from Kansas K-TAG and Texas EZ TAG. Toll charges are matched by license plate and trip timestamps, compiling itemized guest PDFs and official DriveKS statements with custom markups.</p>
              <span className="pill-badge">K-TAG & EZ TAG Direct Ingestion</span>
            </div>

            <div className="card">
              <div className="card-icon">
                <Tool size={24} color="#ff6b35" />
              </div>
              <h3>4-Wheel Tire Health & Safety</h3>
              <p>Avoid blowout liabilities and premature tire wear. Log individual tire PSI and tread depth in 32nds, track NHTSA safety recall advisories, and maintain complete digital service inspection histories.</p>
              <span className="pill-badge">Tread Depth (32nds) & Recalls</span>
            </div>

            <div className="card">
              <div className="card-icon">
                <Clock size={24} color="#ff6b35" />
              </div>
              <h3>Preventative Templates</h3>
              <p>Standardize service packages across vehicle models. Define dual-trigger thresholds (e.g. Synthetic Oil every 5,000 miles or 6 months) and receive automated notifications before service is overdue.</p>
              <span className="pill-badge">Mileage & Time Interval Alerts</span>
            </div>

            <div className="card">
              <div className="card-icon">
                <Package size={24} color="#ff6b35" />
              </div>
              <h3>Parts Inventory & QR Labels</h3>
              <p>Manage spare oil filters, brake pads, key fobs, and wiper blades. Generate and print instant QR stickers for garage storage bins and trigger reorder alerts when inventory dips below minimums.</p>
              <span className="pill-badge">Printable Shelf Label Stickers</span>
            </div>

            <div className="card">
              <div className="card-icon">
                <MessageCircle size={24} color="#ff6b35" />
              </div>
              <h3>Team Hub & @Mentions</h3>
              <p>Coordinate cleaning, maintenance, and vehicle handoffs with co-hosts, dispatchers, and detailers. Tag teammates with @mentions and link messages directly to specific vehicle identification tags.</p>
              <span className="pill-badge">Live Audit Trail & Unread Badges</span>
            </div>
          </div>
        </section>

        {/* Why Us Comparison Section */}
        <section id="why-us" className="why-us">
          <div className="section-title">
            <span className="badge-subtitle">THE COMPETITIVE DIFFERENCE</span>
            <h2>Why Traditional Tools Hold You Back</h2>
            <p>See how CarVerse360 replaces manual spreadsheets and fragile browser scrapers.</p>
          </div>

          <div className="comparison-grid">
            <div className="comparison-card traditional">
              <h3 className="traditional-title"><XCircle size={22} color="#dc3545" style={{ marginRight: '8px' }} /> The Traditional Way</h3>
              <ul>
                <li><XCircle size={18} color="#dc3545" /> <span><strong>Manual Booking Entry:</strong> Copying Turo trip times into spreadsheets by hand or relying on fragile Chrome extensions that crash when Turo updates.</span></li>
                <li><XCircle size={18} color="#dc3545" /> <span><strong>Uncollected Toll Revenue:</strong> Spending hours squinting at toll authority PDF bills trying to figure out which renter crossed which plaza.</span></li>
                <li><XCircle size={18} color="#dc3545" /> <span><strong>Reactive Maintenance:</strong> Discovering bald tires, missed oil changes, and expired recalls only after a car breaks down during a guest trip.</span></li>
                <li><XCircle size={18} color="#dc3545" /> <span><strong>Fragmented Chaos:</strong> One app for messaging, another for parts, three different spreadsheets for financials, zero unified records.</span></li>
              </ul>
            </div>

            <div className="comparison-card highlight">
              <div className="highlight-tag">RECOMMENDED</div>
              <h3 className="highlight-title"><CheckCircle size={22} color="#10b981" style={{ marginRight: '8px' }} /> With CarVerse360</h3>
              <ul>
                <li><CheckCircle size={18} color="#10b981" /> <span><strong>Zero-Touch Cloud Sync:</strong> Connect Gmail OAuth once. Bookings, trip extensions, and guest names import automatically 24/7 in the cloud.</span></li>
                <li><CheckCircle size={18} color="#10b981" /> <span><strong>1-Click Toll Invoices:</strong> Upload K-TAG or EZ TAG CSVs and get instant itemized PDF invoices and official DriveKS statements with markups.</span></li>
                <li><CheckCircle size={18} color="#10b981" /> <span><strong>Proactive Tire & Service Radar:</strong> 4-wheel PSI and 32nds tread monitoring, NHTSA recall alerts, and automated interval dispatches.</span></li>
                <li><CheckCircle size={18} color="#10b981" /> <span><strong>Unified Multi-Tenant Platform:</strong> Complete tenant data isolation, role-based controls, parts QR inventory, and teammate @mentions.</span></li>
              </ul>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section id="testimonials" className="testimonials">
          <div className="section-title">
            <span className="badge-subtitle">TRUSTED BY OPERATORS</span>
            <h2>Voice of the Host</h2>
            <p>Here is what real fleet hosts say about operating on CarVerse360.</p>
          </div>

          <div className="testimonial-cards">
            <div className="testimonial-card">
              <div className="stars">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="#f59e0b" color="#f59e0b" />)}
              </div>
              <p>"CarVerse360 has completely transformed how I manage my 14-car Turo fleet. The automated Gmail sync alone saves me over 5 hours every single week."</p>
              <div className="author">
                <h4>John D.</h4>
                <span>Turo Power Host (14 Cars)</span>
              </div>
            </div>

            <div className="testimonial-card">
              <div className="stars">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="#f59e0b" color="#f59e0b" />)}
              </div>
              <p>"Finally, a toll management solution that doesn't involve manual spreadsheets. We uploaded our K-TAG statement and had all guest invoices generated in 30 seconds."</p>
              <div className="author">
                <h4>Sarah M.</h4>
                <span>Independent Fleet Owner (26 Cars)</span>
              </div>
            </div>

            <div className="testimonial-card">
              <div className="stars">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="#f59e0b" color="#f59e0b" />)}
              </div>
              <p>"The tire tread depth tracking and recall alerts saved us from a major safety violation. This is the only fleet platform built specifically for modern car-sharing."</p>
              <div className="author">
                <h4>Marcus T.</h4>
                <span>Fleet Co-Host & Operations Lead</span>
              </div>
            </div>
          </div>
        </section>

        {/* High-Impact Closing CTA Banner */}
        <section className="cta-banner-section">
          <div className="cta-banner">
            <span className="cta-badge">BETA INVITATION NOW OPEN</span>
            <h2>Scale Your Fleet Without Operational Headaches</h2>
            <p>Join forward-thinking Turo hosts and rental operators automating their daily operations on CarVerse360.</p>
            <div className="cta-banner-buttons">
              <a href="https://app.carverse360.com/signup" className="cta-button primary large">
                Register Your Fleet Free <ArrowRight size={18} style={{ marginLeft: '8px' }} />
              </a>
              <a href="https://app.carverse360.com/login" className="cta-button outline">Sign In</a>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="main-footer">
        <div className="footer-container">
          <div className="footer-brand">
            <div className="logo-badge">
              <span>CV</span>
              <h3>CarVerse360</h3>
            </div>
            <p>The intelligent operating platform built for car-sharing hosts, independent rental operators, and commercial vehicle fleets.</p>
            <div className="compliance-badges">
              <span className="badge">100% Tenant Isolated</span>
              <span className="badge">Google Limited Use Compliant</span>
            </div>
          </div>

          <div className="footer-links-group">
            <div className="footer-col">
              <h4>Platform</h4>
              <ul>
                <li><a href="https://app.carverse360.com">Fleet App</a></li>
                <li><a href="https://app.carverse360.com/login">Sign In</a></li>
                <li><a href="https://app.carverse360.com/signup">Register Fleet</a></li>
                <li><a href="/store">Hardware Shop</a></li>
              </ul>
            </div>

            <div className="footer-col">
              <h4>Legal & Privacy</h4>
              <ul>
                <li><a href="/privacy">Privacy Policy</a></li>
                <li><a href="/terms">Terms of Service</a></li>
                <li><a href="mailto:privacy@carverse360.com">Data Protection</a></li>
                <li><a href="mailto:support@carverse360.com">Support Team</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} CarVerse360, Inc. All rights reserved.</p>
          <div className="footer-bottom-links">
            <a href="/privacy">Privacy</a>
            <span>•</span>
            <a href="/terms">Terms</a>
            <span>•</span>
            <a href="https://app.carverse360.com">Fleet App</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
